// services/spacePage.services.js
import { API_BASE_URL } from '../config';

const baseUrl = API_BASE_URL;

export const fetchSpaceData = async (placeId, lang = "fr") => {
  try {
    // Load base URL from environment variables
    if (!baseUrl) {
      throw new Error("API base URL is not defined in environment variables");
    }

    // Get the authentication token from localStorage - matching your initialState
    let token = null;
    
    // Your auth uses accessToken in localStorage
    token = localStorage.getItem('accessToken');
    
    if (token) {
      console.log('[fetchSpaceData] Token found in localStorage accessToken');
    } else {
      console.log('[fetchSpaceData] No token found - public access');
    }

    // Construct the full URL
    const url = `${baseUrl}places/${placeId}?lang=${
      lang === "uk" ? "en" : lang
    }`;

    console.log('[fetchSpaceData] Fetching space data:', {
      url,
      hasToken: !!token,
      placeId,
      lang
    });

    // Prepare headers
    const headers = {
      "Content-Type": "application/json",
    };

    // Add authorization header if token exists
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    // Fetch data from the API
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    // Handle the response
    if (!response.ok) {
      // If unauthorized, we might want to handle differently
      if (response.status === 401) {
        console.warn("[fetchSpaceData] Unauthorized access - user may need to login again");
      } else if (response.status === 403) {
        console.warn("[fetchSpaceData] Forbidden - user doesn't have permission");
      } else if (response.status === 404) {
        console.warn("[fetchSpaceData] Space not found:", placeId);
      }
      
      throw new Error(
        `Failed to fetch data: ${response.status} ${response.statusText}`
      );
    }

    const responseJson = await response.json();
    const data = responseJson.data;
    
    console.log('[fetchSpaceData] Successfully fetched space data:', {
      spaceId: data?.id,
      status: data?.status,
      hasToken: !!token
    });
    
    return data;
  } catch (error) {
    console.error("Error fetching place data:", error);
    throw error; // Re-throw the error for the caller to handle
  }
};